const removeUnnecessaryAriaAttr = (swiper) => {
	const allSlides = swiper.el.querySelectorAll('.swiper-slide');
	allSlides.forEach((slide) => {
		if (slide.getAttribute('aria-label') === 'slide 1 of 1') {
			slide.removeAttribute('aria-label');
			slide.removeAttribute('role');
		}
	});
};

export default removeUnnecessaryAriaAttr;
